import { useContext, useState } from "react";

import { ModalContainer } from "./styled";

import Button from "components/Form/Button";
import { CoreContext } from "context/CoreContext";

export default function GenericDeleteModal({
  description = "Deseja remover esta campanha?",
  buttonText = "REMOVER",
  buttonTextCancel = "CANCELAR",
}) {
  const { modal, setModal } = useContext(CoreContext);
  const [loading, setLoading] = useState(false);
  const confirmAction = () => {
    setLoading(true);
    modal?.item?.onClick();
    close();
  };
  const close = () => {
    setModal(null);
  };

  return (
    <>
      <ModalContainer>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "12px",
            width: "480px",
            height: "275px",
            background: "rgba(255, 255, 255, 1)",
            borderRadius: "8px",
            padding: "16px",
          }}
        >
          <img
            src="/icons/close.svg"
            width={"10px"}
            height={"10px"}
            style={{ alignSelf: "end", cursor: "pointer" }}
            onClick={close}
          />

          <img
            src="/icons/delete-folder.svg"
            width={"64px"}
            height={"64px"}
            style={{ marginTop: "22px" }}
          />
          <p style={{ margin: 0 }}>
            {modal?.item?.description ? modal?.item?.description : description}
          </p>
          <div style={{ display: "flex", gap: "8px" }}>
            <Button outline primary onClick={close} minWidth={"136px"}>
              {buttonTextCancel}
            </Button>
            <Button
              primary
              onClick={confirmAction}
              loading={loading}
              minWidth={"136px"}
            >
              {buttonText}
            </Button>
          </div>
        </div>
      </ModalContainer>
    </>
  );
}
